import { Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import { translates } from '@/utils/translate';
import { Button } from '@PorkyCol/button';
import { ConfirmDialogProps } from './types';

export default function ConfirmDialog({
  title,
  content,
  action,
  open,
  onClose,
  loading,
  disabled,
  disabledActions,
  maxWidth = 'xs',
  ...other
}: ConfirmDialogProps) {
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth}
      open={open}
      onClose={() => !loading && !disabled && onClose()}
      {...other}
    >
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2', py: 1 }}> {content} </DialogContent>}

      {!disabledActions && (
        <DialogActions sx={{ pt: '16px !important' }}>
          {action}

          <Button
            variant="outline"
            label={translates.cancel}
            color="secondary"
            onClick={onClose}
            loading={loading}
            disabled={loading || disabled}
          />
        </DialogActions>
      )}
    </Dialog>
  );
}
